import Configuration from "../shared/configuration";
import EndPointEntity from "../shared/endpointentity";
import API from "../shared/API";
import jwt from "jsonwebtoken";
import Common from "./common";

export default class termsandconditionsservice {
  constructor() {
    this.config = new Configuration();
    this.endpoint = new EndPointEntity();
    this.common = new Common();
  }
  handleError = () => {
    return null;
  };
 

  async deleteTermsAndConditions(TermsAndConditionIDs) {
    const myApi = new API({ url: this.config.ITEM_URL });
    myApi.createEntity({ name: this.endpoint.DELETE_TERMS_AND_CONDITIONS });
    let itemArray = [];
    let ID = "?TermsAndConditionIDs=" + TermsAndConditionIDs;
    await myApi.endpoints.DeleteTermsAndConditionByID.deleteById(ID)
      .then(({ data }) => {
        itemArray = data;
      })
      .catch((err) => {
        itemArray = this.common.handleError(err)
      });
    if (itemArray.statusCode == 401) {
      await this.common.refreshToken().then((response) => {
        this.common.setToken(response);
        itemArray = this.deleteTermsAndConditions(TermsAndConditionIDs);
      });
    }
    return Promise.resolve(itemArray);  
  }

  async addUpdateTermsAndConditions(postData) {
    const myApi = new API({ url: this.config.ITEM_URL });
    myApi.createEntity({ name: this.endpoint.ADD_UPDATE_TERMS_AND_CONDITIONS });
    let itemArray = [];
    await myApi.endpoints.SaveUpdateTermsAndConditions.create(postData)
      .then(({ data }) => {
        itemArray = data;
      })
      .catch((err) => {
        itemArray = this.common.handleError(err)
      });
    if (itemArray.statusCode == 401) {
      await this.common.refreshToken().then((response) => {
        this.common.setToken(response);
        itemArray = this.addUpdateTermsAndConditions(postData);
      });
    }
    return Promise.resolve(itemArray);
  }

  

  async getAllTermsAndConditionsList(
    index,
    size,
    sortColumn,
    sortOrder,
    search
  ) {
    const myApi = new API({ url: this.config.ITEM_URL });
    myApi.createEntity({ name: this.endpoint.TERMS_AND_CONDITIONS_LIST });
    let itemArray = [];
    await myApi.endpoints[this.endpoint.TERMS_AND_CONDITIONS_LIST]
      .getAllPost({
        termsAndConditionID: null,
        termsAndCondition: null,
        pageIndex: index,
        pageSize: size,
        sortColumn: sortColumn,
        sortOrder: sortOrder,
        commonSearch: search,
      })
      .then(({ data }) => {
        itemArray = data;
      })
      .catch((err) => {
        itemArray = this.common.handleError(err);
      });
    if (itemArray.statusCode == 401) {
      await this.common.refreshToken().then((response) => {
        this.common.setToken(response);
        itemArray = this.getAllTermsAndConditionsList(
          index,
          size,
          sortColumn,
          sortOrder,
          search
        );
      });
    }
    return Promise.resolve(itemArray);
  }
}
